/* istanbul ignore file */
import * as React from 'react';
import compose from 'recompose/compose';
import get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import Script from 'react-load-script';
import PropTypes from 'prop-types';
import initInlineManual, { getInlineManualUrl, updateInlineManual } from './helper';

export const InlineManualComponent = ({ viewer, location = {} }) => {
  const [trackingData, setTrackingData] = React.useState();
  const token = get(viewer, 'idToken');

  React.useEffect(() => {
    updateInlineManual();
  }, [location.pathname]);

  React.useEffect(() => {
    if (token) {
      const data = {
        uid: token['cognito:username'],
        roles: [token['custom:role']],
      };
      setTrackingData(true);
      window.inlineManualTracking = { ...data };
    }
  }, [token]);

  return trackingData ? <Script id="inline-manual" url={getInlineManualUrl()} onLoad={initInlineManual} /> : null;
};

InlineManualComponent.propTypes = {
  viewer: PropTypes.object,
  location: PropTypes.object,
};

const InlineManual = compose(
  withRouter,
)(InlineManualComponent);

export default InlineManual;
